import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
//import './plugins/bootstrap-vue'
import App from './App.vue'
import router from './router'
import store from './store'
import * as firebase from 'firebase/app';
import myFirebaseSetup from '@/models/myFirebaseSetup.js';

// Bootstrap & Cartzilla CSS
//import 'bootstrap/dist/css/bootstrap.min.css'
//import 'bootstrap-vue/dist/bootstrap-vue.css'
import '@/cartzilla/css/theme.min.css'
import '@/cartzilla/css/vendor.min.css'
import '@/cartzilla/css/chartist.min.css'
import '@/cartzilla/css/prism.min.css'


// Initialize Firebase
firebase.initializeApp(myFirebaseSetup.config);

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

// TODO
/* 
*/ 